import _slicedToArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WorkingHoursDay from "./WorkingHoursDay";
import { i18n } from 'boot/i18n';
export default {
  components: {
    WorkingHoursDay: WorkingHoursDay
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [{
          value: 0,
          label: i18n.t('days.sunday').substring(0, 3),
          slots: [{
            start: '09:00',
            end: '17:00'
          }]
        }, {
          value: 1,
          label: i18n.t('days.monday').substring(0, 3),
          slots: [{
            start: '09:00',
            end: '17:00'
          }]
        }, {
          value: 2,
          label: i18n.t('days.tuesday').substring(0, 3),
          slots: [{
            start: '09:00',
            end: '17:00'
          }]
        }, {
          value: 3,
          label: i18n.t('days.wednesday').substring(0, 3),
          slots: [{
            start: '09:00',
            end: '17:00'
          }]
        }, {
          value: 4,
          label: i18n.t('days.thursday').substring(0, 3),
          slots: [{
            start: '09:00',
            end: '17:00'
          }]
        }, {
          value: 5,
          label: i18n.t('days.friday').substring(0, 3),
          slots: [{
            start: '09:00',
            end: '17:00'
          }]
        }, {
          value: 6,
          label: i18n.t('days.saturday').substring(0, 3),
          slots: [{
            start: '09:00',
            end: '17:00'
          }]
        }];
      }
    },
    resetEnabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dayOptions: [{
        label: this.$t('days.sunday').substring(0, 3),
        value: 0
      }, {
        label: this.$t('days.monday').substring(0, 3),
        value: 1
      }, {
        label: this.$t('days.tuesday').substring(0, 3),
        value: 2
      }, {
        label: this.$t('days.wednesday').substring(0, 3),
        value: 3
      }, {
        label: this.$t('days.thursday').substring(0, 3),
        value: 4
      }, {
        label: this.$t('days.friday').substring(0, 3),
        value: 5
      }, {
        label: this.$t('days.saturday').substring(0, 3),
        value: 6
      }]
    };
  },
  computed: {
    workingHoursTotal: function workingHoursTotal() {
      var _this = this;

      return this.workingDays.reduce(function (acc, day) {
        return acc + day.slots.reduce(function (acc, slot) {
          if (_this.selectedDays.includes(day.value)) {
            return acc + _this.getSlotMinutes(slot.start, slot.end);
          }

          return acc;
        }, 0);
      }, 0);
    },
    workingDays: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    selectedDays: {
      get: function get() {
        return this.workingDays.map(function (day) {
          return day.value;
        });
      },
      set: function set(val) {
        var _this2 = this;

        var workingDays = _toConsumableArray(this.workingDays);

        val.forEach(function (day) {
          if (val.length > workingDays.length) {
            if (!workingDays.find(function (d) {
              return d.value === day;
            })) {
              workingDays.push({
                value: day,
                label: _this2.dayOptions.find(function (d) {
                  return d.value === day;
                }).label,
                slots: [{
                  start: '09:00',
                  end: '17:00'
                }]
              });
            }
          } else {
            workingDays = workingDays.filter(function (d) {
              return val.includes(d.value);
            });
          }
        });
        this.workingDays = workingDays.sort(function (a, b) {
          return a.value - b.value;
        });
      }
    }
  },
  methods: {
    getSlotMinutes: function getSlotMinutes(start, end) {
      var _start$split$map = start.split(':').map(Number),
          _start$split$map2 = _slicedToArray(_start$split$map, 2),
          startHour = _start$split$map2[0],
          startMinute = _start$split$map2[1];

      var _end$split$map = end.split(':').map(Number),
          _end$split$map2 = _slicedToArray(_end$split$map, 2),
          endHour = _end$split$map2[0],
          endMinute = _end$split$map2[1];

      return endHour * 60 + endMinute - (startHour * 60 + startMinute);
    },
    updateDay: function updateDay(val, day) {
      this.workingDays = this.workingDays.map(function (d) {
        if (d.value === day) {
          return val;
        }

        return d;
      });
    }
  }
};